module.exports = __webpack_public_path__ + "img/about-1.3916120a.jpg";